import { SxProps, Theme } from "@mui/material";

export const chart: SxProps<Theme> = {
	width: "100px",
};
